/**
 * Sichere Rücksprung-Adresse nach der Anmeldung.
 *
 * Die Adresse kommt aus dem Fragezeichen-Teil der URL und ist damit von außen
 * bestimmbar — sie darf nur auf eine Seite dieser Anwendung zeigen, nie auf eine
 * fremde. Bis 18.08.2026 lag dieselbe Prüfung in vier Kopien vor (Anmeldung,
 * Zwei-Faktor-Abfrage, Zwei-Faktor-Einrichtung, Gerätekopplung) und übersah
 * jeweils denselben Fall:
 *
 *   /\böse.example
 *
 * Browser lesen einen Rückwärtsstrich an dieser Stelle wie einen Schrägstrich,
 * `/\böse.example` wirkt also wie `//böse.example` — eine Adresse auf fremdem
 * Rechner. Geprüft wurden nur `//` und `/http`. Genau dieser Weg ist auch als
 * Schwachstelle in React Router bis 7.18 beschrieben; hier lag er zusätzlich im
 * eigenen Code (Auth-Review 18.08.2026).
 *
 * Statt einer Liste verbotener Formen prüft diese Fassung positiv: erlaubt ist
 * nur, was mit genau einem Schrägstrich beginnt und danach ein unverdächtiges
 * Zeichen trägt.
 */

/** Wohin es geht, wenn keine oder eine unzulässige Adresse mitkam. */
export const START_NACH_ANMELDUNG = '/admin/heute';

export function sichereRuecksprungAdresse(
  adresse: string | null | undefined,
  ersatz: string = START_NACH_ANMELDUNG,
): string {
  if (!adresse) return ersatz;

  // Steuerzeichen und Leerraum am Rand entfernen — sie können Prüfungen
  // aushebeln, weil Browser sie beim Auflösen der Adresse verwerfen.
  const geputzt = adresse.trim().replace(/[ -]/g, '');

  // Muss ein einzelner Schrägstrich am Anfang sein, gefolgt von etwas, das kein
  // zweiter Schrägstrich, kein Rückwärtsstrich und kein Doppelpunkt ist.
  if (!/^\/(?![/\\])/.test(geputzt)) return ersatz;

  // Kein Schema irgendwo am Anfang (z. B. "/javascript:…" nach Umwegen).
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(geputzt)) return ersatz;

  return geputzt;
}
